import pDebounce from "p-debounce";
import PQueue from "p-queue";
import { Platform } from "quasar";

// const url = process.env.NODE_ENV === 'development' ? '/api/' : 'https://entrega.soluzion.com.br/api/'
// const url = "https://entrega.soluzion.com.br/api/";

function none() {}

function defer() {
  const deferred = {
    onabort: null,
  };
  const promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  deferred.promise = promise;
  promise.abort = function (message = "Abort") {
    deferred.reject(new Error(message));
    deferred.resolve = none;
    deferred.reject = none;
    if (deferred.onabort) deferred.onabort();
  };
  return deferred;
}

export default ({ Vue, store }) => {
  const urlPrimary = "https://entrega.soluzion.com.br/api/";
  const urlSecondary = "https://entrega2.soluzion.com.br/api/";

  const queuePrimary = new PQueue({ concurrency: 1 });
  const queueSecondary = new PQueue({ concurrency: 2 });

  const getInfo = () => ({
    version: store.state.version,
    is: Platform.is,
    storage: "idb-keyval",
  });

  const fetchRPC = async (method, params, url, queue) =>
    queue.add(async () => {
      try {
        const response = await fetch(url, {
          cache: "no-cache",
          headers: {
            Authorization: `Bearer ${store.state.accessToken}`,
            "X-Client-Version": store.state.version,
            "Content-Type": "application/json",
          },
          method: "post",
          body: JSON.stringify({ method, params, info: getInfo() }),
        });
        if (!response.ok) {
          if (response.status === 401) {
            throw new Error(
              "Sua sessão expirou. Por favor, faça login novamente."
            );
          }
          throw new Error(
            `Falha na comunicação com o servidor. Status: ${response.status}`
          );
        }
        store.commit(
          "setServerVersion",
          response.headers.get("X-Server-Version")
        );
        return response.json();
      } catch (err) {
        if (`${err}`.toLocaleLowerCase().includes("fetch")) {
          throw new Error(
            "Sem conexão com a API. Verifique sua internet e tente novamente."
          );
        }
        if (err instanceof SyntaxError) {
          throw new Error("Resposta do servidor inválida.");
        }
        throw err;
      }
    });

  const requestsPrimary = [];
  const requestsSecondary = [];

  const createBatchRPC = (requests, url, queue, maxRequests, self) =>
    pDebounce(async () => {
      const arr = maxRequests ? requests.splice(0, maxRequests) : requests.splice(0);

      if (arr.length === 0) return;

      try {
        if (process.env.NODE_ENV === "development") {
          console.log(
            `[RPC] batch ${url}`,
            JSON.stringify(
              arr.map(({ method, params }) => ({ method, params }))
            )
          );
        }
        const r = await fetchRPC(
          "batch",
          arr.map(({ method, params }) => ({ method, params })),
          url,
          queue
        );

        if ("data" in r) {
          arr.forEach((o, i) => {
            if (process.env.NODE_ENV === "development") {
              console.log(
                "[RPC] ok",
                JSON.stringify({
                  method: o.method,
                  params: o.params,
                }),
                r.data[i]
              );
            }
            if ("data" in r.data[i]) o.deferred.resolve(r.data[i]);
            else {
              const err = new Error(r.data[i].error);
              if (process.env.NODE_ENV === "development") {
                console.log(
                  "[RPC] error",
                  JSON.stringify({
                    method: o.method,
                    params: o.params,
                  }),
                  err
                );
              }
              o.deferred.reject(err);
            }
          });
        } else {
          const err = new Error(r.error);
          if (process.env.NODE_ENV === "development") {
            console.log("[RPC] error", r);
          }
          arr.forEach((o) => o.deferred.reject(err));
        }
      } catch (err) {
        if (process.env.NODE_ENV === "development") {
          console.log("[RPC] catch error", err);
        }
        arr.forEach((o) => o.deferred.reject(err));
      }

      if (requests.length) await self();
    }, 16);

  const batchRPCPrimary = createBatchRPC(
    requestsPrimary,
    urlPrimary,
    queuePrimary,
    false,
    () => batchRPCPrimary()
  );
  const batchRPCSecondary = createBatchRPC(
    requestsSecondary,
    urlSecondary,
    queueSecondary,
    2,
    () => batchRPCSecondary()
  );

  function rpc(method, params) {
    const isMotorista = store.getters.isMotorista;
    const isReadMethod =
      method.startsWith("list_") ||
      method.startsWith("get_") ||
      method.startsWith("card_") ||
      (method.includes("/") &&
        (method.endsWith("/find") || method.endsWith("/get")));

    const useSecondary = !isMotorista && isReadMethod;

    const targetRequests = useSecondary ? requestsSecondary : requestsPrimary;
    const targetBatch = useSecondary ? batchRPCSecondary : batchRPCPrimary;

    const id = JSON.stringify({ method, params });
    const found = targetRequests.find((b) => b.id === id);
    let deferred;
    if (found) {
      if (process.env.NODE_ENV === "development") {
        console.log(
          "[RPC] already scheduled",
          id,
          useSecondary ? "(secondary)" : "(primary)"
        );
      }
      deferred = found.deferred;
    } else {
      if (process.env.NODE_ENV === "development") {
        console.log(
          "[RPC] schedule",
          id,
          useSecondary ? "(secondary)" : "(primary)"
        );
      }
      deferred = defer();
      targetRequests.push({ id, method, params, deferred });
      targetBatch();
    }
    const d = defer();
    deferred.promise.then(d.resolve).catch(d.reject);
    return d.promise;
  }

  async function srpc(method, params) {
    const r = await rpc(method, params);
    if (r.error) throw new Error(r.error);
    return r.data;
  }

  Vue.prototype.$rpc = rpc;
  store.$rpc = rpc;

  Vue.prototype.$srpc = srpc;
  store.$srpc = srpc;

  if (process.env.NODE_ENV === "development") {
    window.$rpc = rpc;
    window.$srpc = srpc;
  }
};
